import axios, { AxiosResponse } from 'axios';
import { CommonService } from './common.services';
import { CustomMailRequest } from './suite.interfaces';

export class NotificacionService extends CommonService {

  async sendMail(evento: number, acreditado: number, template: number, mailto: string): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(this.getServerUrl() + '/mobile/sendMail?acreditado=' + acreditado + '&evento=' + evento + '&mailTo=' + mailto + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data as String;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async sendMailAcreditado(evento: number, acreditado: number, template: number): Promise<boolean> {
    try {
      const response: AxiosResponse<String> = await axios.get(this.getServerUrl() + '/mobile/sendMailAcreditado?acreditado=' + acreditado + '&evento=' + evento + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data == "OK");
    } catch (error) {
      throw this.manageError(error);
    }
  }
  

  async sendWhatsApp(evento: number, acreditado: number, template: number, phone: string): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(this.getServerUrl() + '/mobile/sendMail?acreditado=' + acreditado + '&evento=' + evento + '&phone=' + phone + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data as String;
    } catch (error) {
      throw this.manageError(error);
    }
  }
  
  async agendarNotificacion(evento: number, acreditado: number, notificacion: number): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(this.getServerUrl() + '/mobile/agendarNotificacion?acreditado=' + acreditado + '&evento=' + evento + '&notificacion=' + notificacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data as String;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async sendCustomMail(evento: number, subject: string, mailTo:string, mailFromName: string, body:string): Promise<String> {
    try {
      const customMailRequest: CustomMailRequest = {} as CustomMailRequest;
      customMailRequest.subject = subject;
      customMailRequest.mailTo = mailTo;
      customMailRequest.mailFromName = mailFromName;
      customMailRequest.body = body;

      const response: AxiosResponse<String> = await axios.post(this.getServerUrl() + '/mobile/sendCustomMail?evento=' + evento, { "customMailRequest": customMailRequest }, { headers: {"Authorization": this.token, "Client-ID" : this.clientId, "Content-Type": "application/json", "Accept": "application/json" }});
      return response.data as String;
    } catch (error) {
      throw this.manageError(error);
    }
  }
}
